import { reload, signOut } from 'firebase/auth';
import cookie from '../utils/cookie';

export const isEmailNotVerified = error => error?.response?.data?.reason === 'EMAIL_NOT_VERIFIED';

export function emailNotVerifiedError() {
    return Object.assign(new Error('你的邮箱未验证，请验证邮箱后重新登录。'), {
        response: { status: 403, data: { reason: 'EMAIL_NOT_VERIFIED' } },
    });
}

// Refresh both the user profile and signed claims after a verification link
// has been opened, rather than trusting the persisted Firebase user snapshot.
export async function verifiedAdminToken(user) {
    await reload(user);
    if (!user.email || user.emailVerified !== true) throw emailNotVerifiedError();
    const result = await user.getIdTokenResult(true);
    if (result.claims.email_verified !== true) throw emailNotVerifiedError();
    return result.token;
}

export function clearAdminCredentials() {
    cookie.deleteCookie('user-token');
    window.localStorage.removeItem('rjwt');
    window.dispatchEvent(new Event('admin-session-cleared'));
}

export async function signOutAdmin(auth) {
    clearAdminCredentials();
    await signOut(auth);
}
